import type { DomainMapper } from '../types';

const base = {
  countryCode: 'dk',
  currency: 'DKK',
  dataAreaId: 'se01',
  environment: 'production',
  flagUrl: '/flags/DK.svg',
  languagePrimary: true,
  locale: 'da',
  logoUrl: 'kahrs-logo',
  noRobots: false,
  productBasePath: 'produkt',
  sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-dk.xml',
  storyblokBasePath: 'dk',
  algoliaIndex: 'b2b-dk-da-DK-products',
  algoliaIndexAutocomplete: 'b2b-dk-da-DK-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1454,
  subFolder: true,
  googleSiteVerification: 'tHG4C4vnMgMxfElDcGevBx5-SKSflV4V5W_Rn6Ao8rM',
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1454,
    algoliaIndex: 'b2b-dk-da-DK-products',
    algoliaIndexAutocomplete: 'b2b-dk-da-DK-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-dk.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1476,
    algoliaIndex: 'b2c-dk-da-DK-products',
    algoliaIndexAutocomplete: 'b2c-dk-da-DK-productsquery_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'produkt',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-dk-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
    sampleRequestNav: true,
  },
  showNonPublicProducts: true,
};

const dk: DomainMapper[] = ['new.kahrs.com', 'www.kahrs.com'].map((domain) => ({
  ...base,
  domain,
  legacyDomain: domain === 'new.kahrs.com',
  url: `https://${domain}/${base.storyblokBasePath}`,
} as DomainMapper));

export default dk;
